export const arrowBackSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23 15.6717L9 15.6717M9 15.6717L15.3284 21.6719M9 15.6717L15.3287 9.67187" stroke="#42526E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
